module.exports = "<h1>Heading\n      <span class=\"badge badge-secondary\">New</span>\n</h1>\n<h2>Heading\n      <span class=\"badge badge-secondary\">New</span>\n</h2>\n<h3>Heading\n      <span class=\"badge badge-secondary\">New</span>\n</h3>\n<h4>Heading\n      <span class=\"badge badge-secondary\">New</span>\n</h4>\n<h5>Heading\n      <span class=\"badge badge-secondary\">New</span>\n</h5>\n<h6>Heading\n      <span class=\"badge badge-secondary\">New</span>\n</h6>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Badge/Badge.html
// module id = 370
// module chunks = 0